import axios from "axios";

export const useClient = (token) => {
    const client = axios.create({
        baseURL: process.env.REACT_APP_STERLING_API_EDNPOINT,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        responseType: 'json'
    });
    return client;
}

export const useAs2Client = (token) => {
    const client = axios.create({
        baseURL: process.env.REACT_APP_EDI_AS2_COMMUNICATION_STATUS_BASE_URL,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        responseType: 'json'
    });
    return client;
}

export const useNotificationAPI = (token) => {
    const client = axios.create({
        baseURL: process.env.REACT_APP_NOTIFICATION_API_BASE_URL,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        responseType: 'json'
    });
    return client;
}

export const useChatbotAPI = (token) => {
    const client = axios.create({
        baseURL: process.env.REACT_APP_CHATBOT_API_URL,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        responseType: 'json'
    });
    return client;
}


export const useDocumentStatusAPI = (token) => {
    const client = axios.create({
        baseURL:  process.env.REACT_APP_DOCUMENT_STATUS_API_URL,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        responseType: 'json'
    });
    return client;
}


export const useMailAPI = (token) => {
    const client = axios.create({
        baseURL: process.env.REACT_APP_MAIL_API_BASE_URL,
        headers: {
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With, X-Auth-Token',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Credentials': true,
            'Authorization': 'Bearer ' + token
        },
        responseType: 'json'
    });
    return client;
}


